// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"21dc2c52","77":"b261698e","173":"b499254b","472":"77068957","642":"627e3b51","837":"01c09213","929":"290f6d85"}[chunkId] + ".chunk.js";
};